<template>
  <regular-bar :config="config">
    <v-menu offset-y="offset-y" left="left" :close-on-content-click="false" content-class="filter-panel">
      <template v-slot:activator="{ on }">
        <div class="button" v-on="on">
          <v-icon>mdi-filter</v-icon>
        </div>
      </template>
      <div class="filter">
        <v-row>
          <v-col cols="12">
            <div class="recent-select">
              <div class="body-1 pb-2 pb-2">{{ $t('filter.recentSelect') }}</div>
              <v-row class="buttons">
                <v-col cols="auto" v-for="city in currentCities" :key="city.value">
                  <v-btn color="primary" outlined="outlined">{{ city.name }}</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="body-1 pb-2 pb-2">{{ $t('filter.bikeStatus') }}</div>
            <v-select :items="deviceStatusOptions" item-text="name" item-value="value" label="Select" color="primary" full-width="full-width" outlined="outlined"></v-select>
          </v-col>
          <v-col cols="6">
            <div class="body-1 pb-2 pb-2">{{ $t('filter.bikeRental') }}</div>
            <v-select :items="rentalStatusOptions" item-text="name" item-value="value" label="Select" color="primary" full-width="full-width" outlined="outlined"></v-select>
          </v-col>
        </v-row>
      </div>
    </v-menu>
    <template v-if="mode === 'view'">
      <router-link class="button" to="/bikes?mode=edit">
        <v-icon>mdi-pencil-box-outline</v-icon>
      </router-link>
      <router-link class="button" to="/bikes/create">
        <v-icon>mdi-plus</v-icon>
      </router-link>
    </template>
    <template v-if="mode === 'edit'">
      <div class="button" @click="showDeletePanel">
        <v-icon>mdi-delete</v-icon>
      </div>
      <v-dialog v-model="showDialog" max-width="500">
        <v-card>
          <v-card-title class="headline error" primary-title="primary-title">
            <h4 class="white--text">{{ $t('deleteBike.title') }}</h4>
          </v-card-title>
          <div class="card-content pl-5 pr-5 mb-10">
            <div class="text-center pt-10 pb-10">
              <v-icon color="error" size="50">mdi-alert</v-icon>
            </div>
            <p class="text-center font-weight-medium is-size-5" v-html="warningOfDelete"></p>
          </div>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn class="mr-5" @click="cancel" color="error" outlined="outlined" min-width="180">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn @click="deleteBikes" color="error" min-width="180">{{ $t('buttons.confirm') }}</v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </regular-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import QueryMode from '@/mixins/QueryMode'
import RegularBar from './Regular'

export default {
  mixins: [QueryMode],
  components: { RegularBar },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showDialog: false,
      currentCities: [
        {
          name: 'Taipei City',
          value: 'taipei'
        },
        {
          name: 'New Taipei City',
          value: 'new_taipei'
        },
        {
          name: 'Keelung City',
          value: 'keelung_taipei'
        }
      ],
      deviceStatusOptions: [
        {
          name: 'Normal',
          value: 'normal'
        },
        {
          name: 'Maintenance',
          value: 'maintenance'
        },
        {
          name: 'Repairing',
          value: 'repairing'
        }
      ],
      rentalStatusOptions: [
        {
          name: 'Available',
          value: 'available'
        },
        {
          name: 'Reserved',
          value: 'reserved'
        },
        {
          name: 'Servicing',
          value: 'servicing'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selected: 'bikes/selected'
    }),
    warningOfDelete () {
      const warningType = this.selected.length > 1 ? 'multipleDelete' : 'singleDelete'
      return this.$t(`deleteBike.${warningType}`, { number: this.selected.length })
    }
  },
  methods: {
    showDeletePanel () {
      if (!this.selected.length) return
      this.showDialog = true
    },
    deleteBikes () {
      if (!this.selected.length) return
      // do action
      this.showDialog = false
      this.$router.push('/bikes')
    },
    cancel () {
      this.showDialog = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .filter-panel
    width 750px
    padding 20px 35px
    background-color white
</style>
